﻿const messages = {
  es: {
    translations: {
      validation: {
        required: "Obligatorio",
        invalid: "Invalido",
        tooShort: "Muy corto",
        tooLong: "Muy largo",
      },
      weekdays: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Mi\u00e9rcoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "S\u00e1bado",
        sunday: "Domingo",
      },
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      login: {
        title: "Inicio de Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
          forcedLogout: "Tu sesión fue finalizada por un administrador.",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
        },
        messages: {
          inAttendance: {
            title: "En servicio"
          },
          waiting: {
            title: "Esperando"
          },
          closed: {
            title: "Finalizado"
          }
        }
      },
      connections: {
        title: "Conexiones",
        presence: {
          online: "Online",
          away: "Ausente",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "No disponible",
          registered: "Registrado",
          offline: "Offline",
        },
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          connecting: "Conectando",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
        },
        extras: {
          searchPlaceholder: "Buscar por nombre",
          filters: "Filtros",
          add: "Agregar",
          disconnectedTitle: "Conexiones desconectadas inesperadamente",
          disconnectedDescription: "Algunas conexiones fueron desconectadas. Esto puede ocurrir por sesion expirada, inestabilidad o perdida temporal de acceso.",
          viewConnections: "Ver conexiones",
          activeTab: "Activas",
          archivedTab: "Archivadas",
          connectionId: "ID de conexion: #{{id}}",
          noDefaultQueue: "Sin cola predeterminada",
          emptyArchived: "Ninguna conexion archivada.",
          empty: "Ninguna conexion encontrada.",
          showingResults: "Mostrando {{visible}} de {{total}} resultados",
          pageLabel: "Pagina 1 de 1",
          view: "Ver",
          archive: "Archivar",
          unarchive: "Restaurar",
          delete: "Borrar",
          breadcrumb: "Conexiones > Agregar conexion",
          addConnectionTitle: "Agregar conexion",
          available: "Disponible",
          availableCount: "{{count}} disponible",
          limitReached: "Limite alcanzado",
          createdConnection: "{{count}} conexion creada.",
          createdConnections: "{{count}} conexiones creadas.",
          contractToUse: "Contrata esta conexion para empezar a usarla.",
          usage: "Uso: {{count}}{{limit}}",
          newConnection: "Nueva conexion",
          request: "Solicitar",
          blockedUnavailable: "Conexion no disponible",
          blockedLimitTitle: "Limite alcanzado para esta conexion",
          blockedNotContractedTitle: "Esta conexion no esta incluida en tu plan",
          blockedComingSoonTitle: "Esta conexion aun esta en preparacion",
          blockedLimitMessage: "Tu plan incluye esta conexion, pero el limite contratado ya fue alcanzado. Contacta soporte para ampliar la capacidad.",
          blockedNotContractedMessage: "Parece que tu plan actual no incluye esta conexion. Contacta soporte para saber como habilitarla en tu cuenta.",
          blockedComingSoonMessage: "Esta conexion esta contratada en el paquete, pero el conector aun no esta disponible en esta version.",
          talkSupport: "Hablar con soporte",
          archiveTitle: "Archivar conexion",
          archiveMessage: "Esta conexion saldra de la lista activa y quedara disponible en la pestana Archivadas.",
          unarchiveTitle: "Restaurar conexion",
          unarchiveMessage: "Esta conexion volvera a la lista de conexiones activas.",
          archivedSuccess: "Conexion archivada.",
          restoredSuccess: "Conexion restaurada.",
          didMissing: "DID no informado",
          metaIdMissing: "ID Meta no informado",
          numberMissing: "Numero no informado",
          configured: "Configurado",
          configure: "Configurar",
          connected: "Conectado",
          connecting: "Conectando",
          connect: "Conectar",
          reconnect: "Reconectar",
          disconnected: "Desconectado",
          pairing: "Emparejando",
          unstable: "Inestable",
          pending: "Pendiente",
          groupActive: "Activo",
          groupInactive: "Desactivado"
        },
      },
      apiTools: {
        introTitle: "Herramientas de integracion operativa",
        introText: "Configura y ejecuta acciones via API directamente en la atencion, con seguridad y auditoria.",
        httpTitle: "Acciones HTTP",
        httpText: "Registro de acciones como segunda copia, desbloqueo y apertura de O.S.",
        permissionsTitle: "Permisos",
        permissionsText: "Control por usuario, con restriccion por accion.",
        auditTitle: "Auditoria",
        auditText: "Registro de ejecuciones para rastrear quien ejecuto, cuando y el resultado.",
        wabaIntro: "Configura las credenciales oficiales por conexion y valida la conectividad con la Cloud API de Meta.",
        loadingConnections: "Cargando conexiones...",
        noWaba: "Aun no hay ninguna conexion WABA registrada. Crea una conexion WABA en Conexiones > Agregar WhatsApp.",
        config: "Configuracion",
        templates: "Templates",
        calls: "Llamadas",
        whatsappConnection: "Conexion WhatsApp",
        enableWaba: "Habilitar WABA en esta conexion",
        generate: "Generar",
        loading: "Cargando...",
        saving: "Guardando...",
        testing: "Probando...",
        saveWaba: "Guardar WABA",
        testConnection: "Probar conexion",
        updateList: "Actualizar lista",
        createTemplate: "Crear template",
        updateCalls: "Actualizar llamadas",
        close: "Cerrar",
        reload: "Recargar"
      },
      companyPage: {
        title: "Empresa",
        refresh: "Actualizar",
        operationTitle: "Operacion del equipo",
        operationDescription: "Centraliza el comportamiento operativo de la empresa en un solo lugar.",
        saveOperation: "Guardar operacion",
        awayMinutes: "Tiempo para considerar ausente (minutos)",
        awayMinutesHelp: "Despues de este tiempo sin actividad, el agente pasa a ausente.",
        subjectRequired: "Asunto del ticket obligatorio",
        subjectRequiredHelp: "Cuando esta activo, el agente debe informar el asunto antes de enviar mensajes en el ticket.",
        autoResumeSla: "Reanudar SLA automaticamente",
        autoResumeSlaHelp: "Cuando esta activo, el contador SLA se reanuda automaticamente cuando el cliente responde.",
        sharedQueue: "Permitir cola compartida para agentes",
        sharedQueueHelp: "Cuando esta activo, los agentes pueden ver tickets de su propia cola, aunque no esten asignados a ellos.",
        loadPreviousTicketMessages: "Cargar mensajes de atenciones anteriores",
        loadPreviousTicketMessagesHelp: "Al desplazarse hacia arriba en la conversación, sigue cargando los mensajes de las atenciones anteriores del mismo contacto. Se puede permitir o negar por usuario.",
        previousTicketMessagesPageSize: "Mensajes por carga",
        previousTicketMessagesPageSizeHelp: "Entre 10 y 100. Vale para toda la conversación, no solo para el historial.",
        pendingCloseByUser: "Permitir que agentes cierren tickets en espera",
        pendingCloseByUserHelp: "Cuando esta activo, los agentes pueden cerrar tickets que aun estan en espera sin aceptarlos primero. Cuando esta desactivado, solo admins pueden hacerlo.",
        previewPending: "Permitir espiar tickets en espera",
        previewPendingHelp: "Cuando esta activo, los agentes pueden abrir una vista previa de tickets en espera sin aceptarlos.",
        recordingsPlayback: "Permitir que agentes escuchen grabaciones",
        recordingsPlaybackHelp: "Cuando esta activo, los agentes pueden reproducir grabaciones de llamadas en los tickets.",
        blockedTitle: "Contactos bloqueados",
        blockedDescription: "Define el mensaje y la accion automatica para contactos y grupos marcados como bloqueados.",
        saveBlocked: "Guardar bloqueo",
        featureDisabled: "Recurso deshabilitado por superadmin para esta empresa.",
        blockedMessage: "Mensaje para contacto bloqueado",
        blockedMessageHelp: "Mensaje enviado automaticamente cuando un contacto o grupo bloqueado envia mensaje.",
        blockedAction: "Accion para contacto bloqueado",
        closeTicket: "Cerrar el ticket",
        keepPending: "Mantener en cola",
        blockedCloseSubject: "Asunto al cerrar ticket bloqueado",
        noSubject: "Sin asunto",
        businessHoursTitle: "Horario de atencion",
        businessHoursDescription: "Define el horario operativo de la empresa, el mensaje de ausencia y el comportamiento fuera de horario o feriados.",
        holidays: "Registrar feriados",
        saveHours: "Guardar horario",
        outOfHoursMessage: "Mensaje de ausencia fuera de horario",
        outOfHoursMessageHelp: "Este mensaje se envia automaticamente fuera del horario. En feriados, el mensaje del feriado tiene prioridad.",
        outOfHoursAction: "Cuando contacten fuera de horario o en feriado",
        day: "Dia",
        active: "Activo",
        start: "Inicio",
        end: "Fin",
        connectionsTitle: "Conexiones de la empresa",
        connectionsDescription: "Administra cola predeterminada, grupos y comportamiento principal de cada conexion.",
        newConnection: "Nueva conexion",
        editConnection: "Editar conexion",
        defaultConnection: "Conexion predeterminada",
        allowGroups: "Atender grupos",
        defaultQueue: "Cola predeterminada de la conexion",
        noDefaultQueue: "Sin cola predeterminada",
        availableQueues: "Colas disponibles en esta conexion:",
        noLinkedQueue: "ninguna cola vinculada",
        routedToDefaultQueue: "Nuevos tickets de esta conexion seran dirigidos a la cola predeterminada.",
        keepCurrentQueueBehavior: "Sin cola predeterminada, se mantiene el comportamiento actual de seleccion de cola.",
        saveConnection: "Guardar conexion",
        activeDays: "{{count}} dias activos",
        noConfiguredDay: "Ningun dia configurado"
      },
      whatsappModal: {
        title: {
          add: "Agrega WhatsApp",
          edit: "Edita WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Por Defecto",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp guardado satisfactoriamente.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
          imported: "Importacion de contactos de WhatsApp completada.",
          invalidImportFile: "Seleccione un archivo CSV o TXT para importar.",
          fileImported:
            "Importacion finalizada. Importados: {{imported}} | Duplicados: {{skippedDuplicates}} | Invalidos: {{skippedInvalid}}.",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          importMessage:
            "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          importPhone: "Importar WhatsApp",
          importFile: "Importar CSV/TXT",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          personType: "PF/PJ",
          document: "CPF/CNPJ",
          email: "Correo Electrónico",
          actions: "Acciones",
          viewHistory: "Ver historial del contacto",
        },
        overview: {
          title: "Historial del contacto",
          contactMeta: "Numero: {{number}} | Email: {{email}}",
          ticketsTitle: "Tickets del contacto",
          noTickets: "No se encontraron tickets para este contacto.",
          noSubject: "Sin asunto",
          close: "Cerrar",
          metrics: {
            total: "Total de tickets",
            open: "En atencion",
            pending: "En espera",
            closed: "Cerrados",
          },
          status: {
            open: "En atencion",
            pending: "En espera",
            closed: "Cerrado",
          },
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          personType: "Tipo de registro",
          document: "CPF/CNPJ",
          documentHelp: "Ingrese el CPF o CNPJ del contacto.",
          personTypeOptions: {
            notInformed: "No informado",
            pf: "PF",
            pj: "PJ",
          },
          extraName: "Nombre del Campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
      },
      quickAnswersModal: {
        title: {
          add: "Agregar respuesta rápida",
          edit: "Editar respuesta rápida",
        },
        form: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Respuesta rápida guardada correctamente.",
      },
      queueModal: {
        title: {
          add: "Agregar cola",
          edit: "Editar cola",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
          description: "Descripción de la cola",
          tags: "Tags de la cola",
          variablesHelp: "Variables: {{name}} y {{protocol}}",
          businessHoursTitle: "Horario por cola",
          useOwnBusinessHours: "Usar horario propio para esta cola",
          outOfHoursMessage: "Mensaje fuera del horario de la cola",
          outOfHoursMessageHelp: "Si esta vacio, se usa el mensaje de ausencia de la empresa.",
          outOfHoursAction: "Accion fuera del horario de la cola",
          keepPending: "Mantener en cola",
          closeTicket: "Cerrar el ticket",
          day: "Dia",
          active: "Activo",
          start: "Inicio",
          end: "Fin",
        },
          buttons: {
            okAdd: "Añadir",
            okEdit: "Ahorrar",
            cancel: "Cancelar",
          },
          success: "Cola guardada con éxito.",
        },
      extensionModal: {
        title: {
          add: "Agregar extension",
          edit: "Editar extension",
        },
        form: {
          extension: "Extension SIP",
          extensionValidation: "Use solo numeros (2 a 10 digitos)",
          zoiperUserHint: "Usuario Zoiper: {{value}}",
          label: "Descripcion",
          user: "Atendente",
          unassigned: "Sin atendente",
          status: "Estado",
          active: "Activo",
          inactive: "Inactivo",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Extension guardada correctamente.",
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          refresh: "Actualizar",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          language: "Idioma",
          languageOptions: {
            pt: "Portugués",
            en: "Inglés",
            es: "Español",
          },
          whatsapp: "Conexión estándar",
          sipUser: "Cuenta SIP",
          sipPassword: "Clave SIP",
          enableSip: "Habilitar SIP",
          enableWabaCalling: "Permitir llamadas WABA",
          enableWabaCallingHelp:
            "Permite mostrar el botón Llamar en los tickets WABA de este usuario.",
          supervisorMode: "Modo supervisor",
          supervisorModeHelp:
            "Libera permisos operativos de supervision sin acceso al menu de administracion.",
          internalChatDeleteDirect: "Borrar conversacion individual del chat interno",
          internalChatDeleteDirectHelp:
            "Borrar elimina la conversacion y todos los mensajes para ambos lados, sin forma de deshacerlo. Sin este permiso el usuario todavia puede salir de la conversacion, lo que solo limpia su propia lista.",
          internalChatDeleteGroup: "Borrar grupo del chat interno",
          internalChatDeleteGroupHelp:
            "Borrar elimina el grupo y el historial para todos los integrantes, sin forma de deshacerlo.",
          internalChatDeleteAdminHelp:
            "El administrador ya puede borrar conversaciones del chat interno por su cargo.",
          queueVisibility: "Ver atenciones de sus colas",
          queueVisibilityCompany: "Seguir la configuración de la empresa",
          queueVisibilityAllow: "Puede ver",
          queueVisibilityDeny: "No puede ver",
          queueVisibilityHelp:
            "Vale para las atenciones de las colas del usuario, incluidas las de otro agente. Seguir la empresa usa la opción general de Configuraciones; las otras dos valen solo para este usuario.",
          queueVisibilityAdminHelp:
            "El administrador ya ve todas las atenciones de la empresa por su cargo.",
          previousTicketMessages: "Cargar mensajes de atenciones anteriores",
          previousTicketMessagesHelp:
            "Al desplazarse hacia arriba en la conversación, sigue cargando los mensajes de las atenciones anteriores del mismo contacto. Seguir la empresa usa la opción general de Configuraciones.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      ticketsManager: {
        tabs: {
          private: "Individuales",
          group: "Grupos",
        },
        buttons: {
          newTicket: "Nuevo",
          search: "Buscar",
          filters: "Filtros",
        },
        activeFiltersSummary: {
          singular: "{{count}} filtro activo",
          plural: "{{count}} filtros activos",
        },
        connectionAlert: {
          notifyAdmin: "Avise a un administrador.",
          checkConnections: "Verifique las conexiones.",
          noConnections: "La empresa no tiene una conexión WhatsApp configurada.",
          qrcode: "Hay una conexión WhatsApp esperando QR Code.",
          connecting: "La conexión WhatsApp está inestable en este momento.",
          inactive: "La empresa no tiene una conexión WhatsApp activa.",
        },
        filters: {
          title: "Filtros avanzados",
          ticketId: "N\u00famero de la atenci\u00f3n",
          ticketIdPlaceholder: "Ej.: 26385",
          subtitle:
            "Refine la operación por cola, agente, conexión, fecha y tags sin perder la vista de la lista.",
          status: "Estado",
          statusOptions: {
            active: "Activos",
            open: "Trabajando en",
            pending: "Cola",
            closed: "Resueltos",
          },
          agent: "Agente",
          connection: "Conexión",
          date: "Fecha",
          all: "Todos",
          allFemale: "Todas",
          hint:
            "Combine cola, agente, conexión, fecha y tags para llegar más rápido a la conversación correcta.",
          clear: "Limpiar",
          cancel: "Cancelar",
          apply: "Aplicar",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Colas",
        noQueue: "Sin cola",
      },
      tickets: {
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
        },
        buttons: {
          showAll: "Todos",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir a la cola",
        fieldConnectionLabel: "Transferir to conexión",
        fieldQueuePlaceholder: "Seleccione una cola",
        fieldConnectionPlaceholder: "Seleccione una conexión",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Cola",
        assignedHeader: "Trabajando en",
        noTicketsTitle: "¡Nada acá!",
        connectionTitle: "Conexión que se está utilizando actualmente.",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        confirmations: {
          closePendingWithoutAccept:
            "¿Desea cerrar sin iniciar la atención?",
        },
        buttons: {
          accept: "Acceptar",
          closePending: "Cerrar",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Añadir",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          profile: "Mi perfil",
          companies: "Empresas",
          announcements: "Avisos",
          backups: "Backups",
          debugLogs: "Logs del sistema",
          dashboard: "Dashboard",
          attendance: "Atención",
          attendanceBadgeUnread: "{{total}} con mensajes sin leer",
          attendanceBadgePending: "{{total}} esperando atención",
          internalChat: "Chat interno",
          internalTickets: "Tickets internos",
          attendances: "Atenciones",
          monitoring: "Monitoreo",
          company: "Empresa",
          connections: "Conexiones",
          tickets: "Tickets",
          contacts: "Contactos",
          quickAnswers: "Respuestas rápidas",
          queues: "Colas",
          extensions: "Extensiones",
          tags: "Tags",
          ticketSubjects: "Asuntos del ticket",
          administration: "Administración",
          users: "Usuarios",
          settings: "Configuración",
        },
        appBar: {
          language: {
            label: "Cambiar idioma",
            options: {
              pt: "Portugués",
              en: "Inglés",
              es: "Español",
            },
          },
          sound: {
            enable: "Activar sonidos de notificación",
            disable: "Silenciar sonidos de notificación",
          },
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      queues: {
        title: "Colas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          description: "Descripción",
          tags: "Tags",
          businessHours: "Horario de la cola",
          actions: "Comportamiento",
        },
        businessHours: {
          own: "Propio",
          company: "Empresa",
        },
          buttons: {
            add: "Agregar cola",
          },
          toasts: {
            deleted: "Cola eliminada con éxito.",
          },
          confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa cola seguirán existiendo, pero ya no tendrán ninguna cola asignada.",
        },
      },
      extensions: {
        title: "Extensiones SIP",
        zoiperHint: "Formato de usuario Zoiper: c{empresa}-{ramal}. Ejemplo: c2-1001.",
        table: {
          extension: "Extension",
          zoiperUser: "Usuario Zoiper",
          label: "Descripcion",
          user: "Atendente",
          status: "Estado",
          actions: "Acciones",
          unassigned: "Sin atendente",
          active: "Activo",
          inactive: "Inactivo",
          sip: "SIP",
          sipOnline: "Online",
          sipOffline: "Offline",
          sipUnavailable: "No disponible",
          sipUnqualified: "No calificado",
        },
        summary: {
          label: "Extensiones",
          unlimited: "Ilimitado",
        },
        buttons: {
          add: "Agregar extension",
        },
        toasts: {
          deleted: "Extension eliminada correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar extension",
          deleteMessage: "Esta seguro? Esta accion no se puede revertir.",
        },
      },
      queueSelect: {
        inputLabel: "Colas",
      },
      quickAnswers: {
        title: "Respuestas rápidas",
        table: {
          shortcut: "Atajo",
          message: "Respuesta rápida",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar respuesta rápida",
        },
        toasts: {
          deleted: "Respuesta rápida eliminada correctamente",
        },
        searchPlaceholder: "Buscar ...",
        confirmationModal: {
          deleteTitle:
            "¿Está seguro de que desea eliminar esta respuesta rápida?",
          deleteMessage: "Esta acción no se puede deshacer.",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo Electronico",
          profile: "Perfil",
          status: "Estado",
          whatsapp: "Conexion estandar",
          sipUser: "Cuenta SIP",
          sipStatus: "Estado SIP",
          supervisor: "Supervisor",
          actions: "Acciones",
        },
        supervisor: {
          enabled: "Activo",
          disabled: "Inactivo",
        },
        buttons: {
          add: "Agregar usuario",
          refresh: "Actualizar",
          disconnect: "Desconectar usuario",
        },
        presence: {
          online: "Online",
          away: "Ausente",
          offline: "Offline",
        },
        sipStatus: {
          unavailable: "No disponible",
          registered: "Registrado",
          offline: "Offline",
        },
        toasts: {
          deleted: "Usuario eliminado correctamente.",
          disconnected: "Usuario desconectado correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos del usuario se perderan. Los tickets abiertos de este usuario se moveran a la cola.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Esta seguro de que desea finalizar la sesion de este usuario ahora?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuración",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Escriba un mensaje o presione '' / '' para usar las respuestas rápidas registradas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        dropHint: "Suelte el archivo para adjuntar",
        dropTooManyFiles: "Solo se adjuntaron los primeros 5 archivos.",
      },
      internalTickets: {
        labels: {
          priority: { low: "Baja", medium: "Media", high: "Alta", urgent: "Urgente" },
          status: { open: "Abierto", in_progress: "En progreso", waiting: "Esperando tercero", done: "Concluido", cancelled: "Cancelado" },
          sla: { unscheduled: "Sin SLA", on_time: "A tiempo", due_soon: "Vence pronto", overdue: "Vencido", completed: "Concluido" },
        },
        page: {
          title: "Tickets internos",
          buttons: { new: "Nuevo ticket interno", refresh: "Actualizar", clearFilters: "Limpiar filtros", openAttendance: "Abrir atencion", edit: "Editar" },
          intro: { title: "Operacion interna vinculada a clientes y atenciones", subtitle: "Monitoree SLA, prioridad y responsable sin mezclar la ejecucion interna con la conversacion del cliente." },
          metrics: { total: "Tickets internos", dueSoon: "Vence pronto", overdue: "Vencidos" },
          filters: { search: "Buscar", status: "Estado", allActive: "Todos (activos)", all: "Todos", mine: "Mis tickets internos", unassigned: "Sin responsable" },
          card: { noDescription: "Sin descripcion adicional.", linkedTicket: "Atencion vinculada", linkedClient: "Cliente vinculado", noLink: "Sin vinculo con cliente o atencion", responsible: "Responsable", notDefined: "No definido", slaUnset: "no configurado", attention: "Atencion" },
          empty: { filtered: "No se encontraron tickets internos con los filtros actuales. Intente limpiar los filtros.", default: "No se encontraron tickets internos." },
        },
        dialog: {
          title: { add: "Nuevo ticket interno", edit: "Editar ticket interno" },
          meta: { protocol: "Protocolo", client: "Cliente", attendance: "Atencion", notLinked: "no vinculado" },
          fields: { noName: "Sin nombre", linkedTicket: "Atencion vinculada", ticketId: "Atencion (ID opcional)", client: "Cliente (opcional)", title: "Titulo", priority: "Prioridad", description: "Descripcion", status: "Estado", responsible: "Responsable", noResponsible: "Sin responsable", finalComment: "Comentario final", newComment: "Nuevo comentario" },
          helpers: { ticketId: "Complete si desea vincular a una atencion especifica.", client: "Busque por nombre, numero o documento (minimo 2 caracteres).", finalCommentRequired: "Obligatorio para concluir el ticket interno.", finalCommentOptional: "Opcional para complementar el cierre." },
          placeholders: { finalComment: "Describa el cierre para registrarlo en el historico." },
          sections: { comments: "Comentarios", history: "Historico" },
          quickComments: { customerReturn: "Esperando respuesta del cliente", thirdParty: "Esperando proveedor/tercero", technicalReview: "En analisis tecnico", waitingValidation: "Accion ejecutada, esperando validacion", internalAlignment: "Necesario nuevo alineamiento interno" },
          history: { loading: "Cargando historico...", system: "Sistema", field: "Campo", empty: "vacio", noEvents: "Aun no hay eventos registrados." },
          toasts: { missingTitle: "Informe un titulo para el ticket interno.", missingResponsible: "Defina un responsable antes de concluir el ticket interno.", missingFinalComment: "Agregue un comentario final para concluir el ticket interno.", missingLink: "Vincule el ticket interno a una atencion y/o cliente.", updated: "Ticket interno actualizado.", created: "Ticket interno creado.", missingComment: "Informe un comentario para agregar al historico.", commentAdded: "Comentario agregado." },
          buttons: { cancel: "Cancelar", okAdd: "Crear ticket interno", okEdit: "Guardar cambios", addComment: "Agregar comentario" },
        },
      },
      tags: {
        title: "Tags",
        table: {
          name: "Nombre",
          color: "Color",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva tag",
        },
        toasts: {
          deleted: "Tag eliminada correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar tag {{name}}?",
          deleteMessage: "Esta accion elimina la tag del registro y de los tickets vinculados.",
        },
      },
      tagModal: {
        title: {
          add: "Nueva tag",
          edit: "Editar tag",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Crear tag",
          okEdit: "Guardar cambios",
          cancel: "Cancelar",
        },
        success: "Tag guardada correctamente.",
      },
      ticketSubjects: {
        title: "Asuntos del ticket",
        table: {
          subject: "Asunto",
          status: "Estado",
          dashboard: "Dashboard",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo asunto",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
        },
        dashboard: {
          count: "Cuenta",
          ignore: "Ignorar",
        },
        toasts: {
          deleted: "Asunto eliminado correctamente.",
        },
        confirmationModal: {
          deleteTitle: "Eliminar asunto {{name}}?",
          deleteMessage: "Esta accion elimina el asunto de la lista de cierre.",
        },
      },
      ticketSubjectModal: {
        title: {
          add: "Nuevo asunto",
          edit: "Editar asunto - ID #{{id}}",
        },
        form: {
          subject: "Asunto",
          active: "Activo",
          countInDashboard: "Contabilizar en el dashboard",
        },
        buttons: {
          okAdd: "Crear asunto",
          okEdit: "Guardar cambios",
          cancel: "Cancelar",
        },
        success: "Asunto guardado correctamente.",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        mainInfo: "Datos de registro",
        personType: "Tipo de registro",
        document: "CPF/CNPJ",
        buttons: {
          edit: "Editar contacto",
        },
        extraInfo: "Otra información",
      },
      ticketOptionsMenu: {
        delete: "Borrar",
        transfer: "Transferir",
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        edit: "Editar",
        delete: "Borrar",
        reply: "Responder",
        editTitle: "Editar mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        edited: "Editado",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      backendErrors: {
        ERR_NO_MESSAGE_FOUND: "Mensaje no encontrado.",
        ERR_MESSAGE_TOO_LONG: "El mensaje editado supera el l\u00edmite permitido.",
        ERR_MESSAGE_EDIT_NOT_ALLOWED: "Este mensaje no se puede editar.",
        ERR_MESSAGE_EDIT_WINDOW_EXPIRED: "WhatsApp ya no permite editar este mensaje.",
        ERR_MESSAGE_EDIT_TYPE_NOT_SUPPORTED: "Este tipo de mensaje no se puede editar.",
        ERR_MESSAGE_EDIT_UNCHANGED: "El texto editado no tiene cambios.",
        ERR_MESSAGE_EDIT_CHANNEL_NOT_SUPPORTED: "Este canal no admite la edici\u00f3n de mensajes.",
        ERR_MESSAGE_DELETE_NOT_ALLOWED: "Este mensaje no se puede eliminar.",
        ERR_MESSAGE_DELETE_CHANNEL_NOT_SUPPORTED: "Este canal no admite la eliminaci\u00f3n de mensajes.",
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Usuario o contraseña inválidos.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la conexión o el formato del archivo.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_CANNOT_DISCONNECT_SELF:
          "No puedes desconectar tu propio usuario con esta acción.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_CONTACT_IMPORT_FILE_REQUIRED:
          "Envie un archivo CSV o TXT para importar contactos.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_TAG_FOUND: "No se encontro ninguna tag con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_NO_EXTENSION_FOUND: "No se encontro ninguna extension con este ID.",
        ERR_EXTENSION_ALREADY_EXISTS:
          "Ya existe una extension con este numero.",
        ERR_EXTENSION_GLOBAL_CONFLICT:
          "Esta extension ya esta en uso por otra empresa SIP activa.",
        ERR_USER_ALREADY_HAS_ACTIVE_EXTENSION:
          "Este agente ya tiene una extension activa.",
        ERR_SIP_PASSWORD_REQUIRED:
          "Defina la contrasena SIP del agente antes de activar/asignar la extension.",
        ERR_EXTENSION_INVALID:
          "Extension invalida. Use solo numeros de 2 a 10 digitos.",
        ERR_SIP_EXTENSION_LIMIT_REACHED:
          "Se alcanzo el limite de extensiones SIP para esta empresa.",
        ERR_NO_EXTERNAL_NUMBER_FOUND:
          "No se encontro ningun numero externo con este ID.",
        ERR_EXTERNAL_NUMBER_ALREADY_EXISTS:
          "Ya existe un numero externo con ese valor.",
        ERR_EXTERNAL_NUMBER_INVALID:
          "Numero externo invalido. Use digitos con + opcional al inicio.",
        ERR_EXTERNAL_NUMBER_DIRECTION_INVALID:
          "Direccion invalida para numero externo.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_TICKET_SUBJECT_REQUIRED:
          "Informe el asunto del ticket antes de enviar mensajes.",
        ERR_TICKET_RESOLUTION_REQUIRED:
          "Informe un breve resumen antes de resolver el ticket.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una cola.",
        ERR_LICENSE_EXPIRED:
          "Licencia expirada. Contacte al soporte para renovar.",
        ERR_LICENSE_NOT_FOUND:
          "Licencia no encontrada. Verifique la LICENSE_KEY configurada.",
        ERR_LICENSE_BINDING_MISMATCH:
          "La licencia esta vinculada a otro entorno. Limpie el binding y valide de nuevo.",
          ERR_BACKEND_UNREACHABLE:
            "No se pudo conectar al backend. Verifique URL, puerto y CORS.",
          ERR_BACKEND_HTTPS_HTTP_MISMATCH:
            "Frontend en HTTPS y backend en HTTP. Use HTTP o habilite HTTPS en backend.",
          ERR_API_TOOL_DOCUMENT_REQUIRED:
            "Esta accion requiere CPF/CNPJ valido en el contacto.",
          ERR_API_TOOL_DOCUMENT_INVALID:
            "CPF/CNPJ invalido para esta accion. Revise el contacto.",
          ERR_API_TOOL_RESULT_TEMPLATE_INVALID:
            "Template de resultado invalido. Revise los campos Mustache usados.",
          ERR_API_TOOL_RESPONSE_MAPPING_INVALID:
            "Mapeo de variables de respuesta invalido. Revise el JSON informado.",
          ERR_API_TOOL_BODY_INVALID_JSON:
            "Body template invalido: JSON mal formado despues de aplicar variables.",
        },
    },
  },
};

export { messages };



